import { render, staticRenderFns } from "./SelectLanguageWidget.vue?vue&type=template&id=06606524&scoped=true&"
import script from "./SelectLanguageWidget.vue?vue&type=script&lang=js&"
export * from "./SelectLanguageWidget.vue?vue&type=script&lang=js&"
import style0 from "./SelectLanguageWidget.vue?vue&type=style&index=0&id=06606524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06606524",
  null
  
)

export default component.exports